<div class="ui_modal_container" *ngIf="displayModal==true">
  <div class="ui_modal modal_width">
      <a href="javascript:void(0);" class="ui_close" (click)="clickedClose('close')"></a>
      <div class="ui_modal_text">{{dialogHeader}}</div>
      <div class="ui_modal_content" *ngIf="dialogContent!=null">{{dialogContent}}</div>
      <div class="ui_modal_content" *ngIf="dialogContentHtml!=null" [innerHTML]="dialogContentHtml">&nbsp;</div>
      
      <div class="ui_modal_btns">
        <a *ngIf="button2!=null" class="ui_btn ui_btn_basic" href="javascript:void(0);" (click)="clickedClose('secondary')" >{{button2}}</a>
        <a class="ui_btn ui_btn_primary" href="javascript:void(0);" (click)="clickedClose('primary')">{{button1}}</a>
      </div>
  </div>
  <div class="block-background" >&nbsp;</div>
</div>